/**
 * Formats a root brand mention filter string into english.
 */
export default function(filter) {
    return Beef.RootBrandFilter.conversationFeedFilterToEnglish(filter);
}